import { createMuiTheme } from '@material-ui/core/styles';
import { darkPalette, lightPalette, } from '@uipath/apollo-core';
import breakpoints from './breakpoints';
import { darkOverrides, lightOverrides, } from './overrides';
import spacing from './spacing';
import typography from './typography';
const globalPropOverrides = { MuiTextField: { InputLabelProps: { shrink: true } } };
let globalTheme = createMuiTheme({
    palette: lightPalette,
    spacing,
    breakpoints,
    overrides: lightOverrides,
    typography,
});
globalTheme.props = globalPropOverrides;
export const apolloMaterialUiThemeLight = globalTheme;
globalTheme = createMuiTheme({
    palette: darkPalette,
    spacing,
    breakpoints,
    overrides: darkOverrides,
    typography,
});
globalTheme.props = globalPropOverrides;
export const apolloMaterialUiThemeDark = globalTheme;
